module.exports = __webpack_public_path__ + "a05020b2698090a72cab45b1c545a602.jpg";